<app-header [TITLE]="'TERMS_AND_CONDITIONS.TITLE' | translate" [BACKBUTTON]="false"></app-header>

<ion-content class="ion-padding imageBackground" fullscreen>
  <app-header [TITLE]="'TERMS_AND_CONDITIONS.TITLE' | translate" [TOHIDE]="true"></app-header>

  @if (!isBlockedApp && isInternetAvailable) {
    <full-height-wrapper classes="ion-flex-center-center ion-full-height">
      @if (wsError.webServiceError && !wsError.isLoadingMp3) {
        <webservice-error></webservice-error>
      }

      @if (!wsError.webServiceError || (wsError.webServiceError && wsError.isLoadingMp3)) {
        @if (!TERMS_AND_CONDITIONS_TEXT) {
          <loader-component></loader-component>
        }

        @if (TERMS_AND_CONDITIONS_TEXT) {
          @if (hasRefusedTermsAndConditions) {
            <ion-row class="ion-text-center">
              <ion-col size="12">
                <ion-label class="ion-text-wrap ion-text-uppercase" color="white" translate>COMMON.ALERT</ion-label>
              </ion-col>

              <ion-col size="12">
                <ion-label class="ion-text-wrap" color="white" translate>COMMON.T&C_REFUSED</ion-label>
              </ion-col>

              <ion-col size="12">
                <ion-button
                  fill="clear"
                  class="buttonWithLato"
                  size="small"
                  (click)="removeRefusedTermsAndConditions()"
                >
                  <ion-label class="ion-text-wrap ion-text-uppercase" translate>COMMON.OK</ion-label>
                </ion-button>
              </ion-col>
            </ion-row>
          } @else {
            <ion-grid>
              <ion-row>
                <ion-col size="6" offset="3">
                  <ion-segment
                    [(ngModel)]="termsAndConditionsLanguage"
                    mode="ios"
                    color="light"
                    (ngModelChange)="changeLanguage()"
                  >
                    @for (lang of translate.langs; track $index) {
                      <ion-segment-button [value]="lang.value"> {{ lang.text }} </ion-segment-button>
                    }
                  </ion-segment>
                </ion-col>
              </ion-row>

              <ion-row>
                <ion-col size="0" sizeMd="1"></ion-col>
                <ion-col size="12" sizeMd="10" class="ion-text-center">
                  <div class="ion-text-wrap white-text" [innerHTML]="TERMS_AND_CONDITIONS_TEXT"></div>
                </ion-col>
              </ion-row>

              <ion-row class="ion-margin-top ion-margin-bottom ion-flex-center-center">
                <ion-col size="6">
                  <ion-button
                    color="garnet-dark"
                    class="buttonWithLato"
                    size="small"
                    (click)="acceptTermsAndConditions()"
                  >
                    <ion-label class="ion-text-wrap ion-text-uppercase" translate>
                      TERMS_AND_CONDITIONS.ACCEPT
                    </ion-label>
                  </ion-button>
                </ion-col>

                <ion-col size="6">
                  <ion-button
                    color="garnet-dark"
                    class="buttonWithLato"
                    size="small"
                    (click)="rejectTermsAndConditions()"
                  >
                    <ion-label class="ion-text-wrap ion-text-uppercase" translate>
                      TERMS_AND_CONDITIONS.REJECT
                    </ion-label>
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          }
        }
      }
    </full-height-wrapper>
  }

  @if (isBlockedApp || !isInternetAvailable) {
    <div class="offlineComponentContainer">
      <not-available-offline
        [featureNotAvailable]="'COMMON.NOT_AVAILABLE_OFFLINE.TERMS_AND_CONDITIONS'"
      ></not-available-offline>
    </div>
  }
</ion-content>

<!-- NB: Serve per poter avere dello spazio aggiuntivo sul footer -->
<ion-footer class="ion-padding ion-no-border"> </ion-footer>
